<main *transloco="let t">
  <section class="wallpaper"></section>

  <section class="content">
    @if (status() === 'loading' || status() === 'redirecting-store') {
      <div class="state-wrapper">
        <div class="logo-wrapper"><p class="logo"></p></div>
        <mat-spinner diameter="48"></mat-spinner>
        <p class="state-text">
          @if (status() === 'redirecting-store') {
            {{ t('Redirecting to store...') }}
          } @else {
            {{ t('Opening app...') }}
          }
        </p>
        <p class="hint">
          {{ t('If nothing happens,') }}
          <a class="store-link" [href]="getStoreUrl()" rel="noopener">
            {{ t('download') }} Anihis
          </a>
        </p>
      </div>
    }

    @if (status() === 'desktop') {
      <div class="state-wrapper">
        <div class="logo-wrapper"><p class="logo"></p></div>
        <h2>Anihis</h2>
        <p class="description">
          {{
            t(
              'Scan this QR code with your mobile device or visit the store links below to download the app.'
            )
          }}
        </p>
        <anihis-desktop-app-download-links
          [qrUrl]="getDesktopQrUrl()"
          [appStoreUrl]="clientAppStoreUrl"
          [playStoreUrl]="clientPlayStoreUrl"
        />
      </div>
    }
  </section>
</main>
